export const getDataCot = (hash, id) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/LinkDetail/${hash}/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getPDFCot = (hash, id) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/PDFCot/${hash}/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getPDFOc = (hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/PDFOc/${hash}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getPDF = (id) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/PDF/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const getPDF2 = (id,hash) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();
    var formdata = new FormData();
    myHeaders.append("Authorization", `Bearer ${localStorage.getItem("ContaKMPCot")}`)
    formdata.append("id", id);
    formdata.append("hash", hash);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/PDF`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}

export const findFile = (hash,id) => {
  return new Promise((resolve, reject) => {
    const myHeaders = new Headers();

    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(`https://conta-api.solucioneskmp.com/CotizacionesUser/GetFile/${hash}/${id}`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result))
      .catch(error => reject(error));
  })
}